export const FPEB_HEADER = 'fpeb.header';
export const FPEB_DESCRIPTION = 'fpeb.description';
export const FPEB_REFRESH = 'fpeb.refresh';
